import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { setBackground, setEditorSettings, setExportMode, setPreset, } from "../../../features/editor-settings/editor-settings.slice";
import { Colour } from "../../colour/colour";
import { Control } from "../../control/control";
import { ControlGroup } from "../../controlGroup/controlGroup";
import { PRESET_SNOW } from "../../../presets/snow";
import { setUserConfig } from "../../../features/config/config.slice";
import { PRESET_FALLOUT } from "../../../presets/fallout";
import { PRESET_LAVA } from "../../../presets/lava";
import { PRESET_SPACE } from "../../../presets/space";
import { PRESET_CLASSIC } from '../../../presets/classic';
import { PRESET_PRIDE } from "../../../presets/pride";
import { Select } from "../../select/select";
import { PRESET_SNOW2 } from "../../../presets/snow2";
import { PRESET_RAIN } from "../../../presets/rain";
export const EditorSettings = ({ editorConfig }) => {
    const { background } = editorConfig;
    const exportMode = editorConfig.exportMode ?? (editorConfig.isReact ? "jsx" : "js");
    const dispatch = useDispatch();
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Editor settings" }), _jsxs("p", { children: ["These settings are ", _jsx("b", { children: "not" }), " exported with your config."] }), _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Preset", tooltip: "Some fun and inspiring presets to try", value: editorConfig.preset, reset: () => {
                            dispatch(setPreset('snow2'));
                            dispatch(setUserConfig(PRESET_SNOW2.userConfig));
                            dispatch(setEditorSettings(PRESET_SNOW2.editorConfig));
                        }, onChange: (event) => {
                            const value = event.target.value;
                            switch (value) {
                                case "snow":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_SNOW.userConfig));
                                    dispatch(setEditorSettings(PRESET_SNOW.editorConfig));
                                    break;
                                case "snow2":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_SNOW2.userConfig));
                                    dispatch(setEditorSettings(PRESET_SNOW2.editorConfig));
                                    break;
                                case "lava":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_LAVA.userConfig));
                                    dispatch(setEditorSettings(PRESET_LAVA.editorConfig));
                                    break;
                                case "space":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_SPACE.userConfig));
                                    dispatch(setEditorSettings(PRESET_SPACE.editorConfig));
                                    break;
                                case "fallout":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_FALLOUT.userConfig));
                                    dispatch(setEditorSettings(PRESET_FALLOUT.editorConfig));
                                    break;
                                case "classic":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_CLASSIC.userConfig));
                                    dispatch(setEditorSettings(PRESET_CLASSIC.editorConfig));
                                    break;
                                case "pride":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_PRIDE.userConfig));
                                    dispatch(setEditorSettings(PRESET_PRIDE.editorConfig));
                                    break;
                                case "rain":
                                    dispatch(setPreset(value));
                                    dispatch(setUserConfig(PRESET_RAIN.userConfig));
                                    dispatch(setEditorSettings(PRESET_RAIN.editorConfig));
                                    break;
                            }
                        }, children: _jsxs(Select, { children: [_jsx("option", { value: "snow", children: "Snow" }), _jsx("option", { value: "snow2", children: "Snow with images" }), _jsx("option", { value: "lava", children: "Lava" }), _jsx("option", { value: "space", children: "Space" }), _jsx("option", { value: "rain", children: "Rain" })] }) }), _jsx(Control, { name: "Export", tooltip: "Choose the language and environment for the generated code.", showOutput: false, reset: () => dispatch(setExportMode("js")), value: exportMode, onChange: (event) => {
                            dispatch(setExportMode(event.target.value));
                        }, children: _jsxs(Select, { children: [_jsx("option", { value: "html", children: "HTML (CDN)" }), _jsx("option", { value: "js", children: "JavaScript" }), _jsx("option", { value: "jsx", children: "JSX (React)" }), _jsx("option", { value: "ts", children: "TypeScript" }), _jsx("option", { value: "tsx", children: "TSX (React)" })] }) }), _jsx(Control, { name: "Background", tooltip: "For testing purposes, you can set the background colour of the page here", showOutput: true, reset: () => {
                            dispatch(setBackground(PRESET_SNOW.editorConfig.background));
                        }, value: background, onChange: (event) => dispatch(setBackground(event.target.value)), children: _jsx(Colour, {}) })] })] }));
};
